/* =========================================================
   Compatibility Pages – Floating Sidebar + Back To Top
   FINAL SAFE VERSION
   ========================================================= */

document.addEventListener('DOMContentLoaded', function () {
  // 只在 compatibility 页面运行
  if (!window.location.pathname.includes('compatibility')) return;

  initCompatibilityFloatingControls();
});

/* ---------------------------------------------------------
   Floating Sidebar + Back To Top (shared visibility)
   --------------------------------------------------------- */
function initCompatibilityFloatingControls() {
  const floatBar = document.querySelector('.compat-float');
  const backToTop = document.getElementById('backToTop');
  const pageTop = document.getElementById('page-top');

  if (!floatBar && !backToTop) return;

  const SHOW_AT = window.innerHeight * 0.35;

  /* === Scroll visibility control === */
  window.addEventListener(
    'scroll',
    () => {
      const shouldShow = window.scrollY > SHOW_AT;

      if (floatBar) {
        floatBar.classList.toggle('is-visible', shouldShow);
      }

      if (backToTop) {
        backToTop.style.display = shouldShow ? 'flex' : 'none';
      }
    },
    { passive: true }
  );

  /* === Back to Top click === */
  if (backToTop) {
    backToTop.addEventListener(
      'click',
      function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (pageTop) {
          pageTop.scrollIntoView({ behavior: 'smooth' });
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      },
      true // 捕获阶段，绕过 Impact 事件
    );
  }
}
(function () {
  function initCompatSliders() {
    var sliders = document.querySelectorAll('.compat-slider');
    if (!sliders.length) return;

    sliders.forEach(function (slider) {
      var viewport = slider.querySelector('.compat-slider__viewport');
      var track = slider.querySelector('.compat-slider__track');
      var slides = slider.querySelectorAll('.compat-slider__slide');
      var btnPrev = slider.querySelector('[data-action="prev"]');
      var btnNext = slider.querySelector('[data-action="next"]');
      var dots = slider.querySelectorAll('.compat-slider__dot');

      if (!viewport || !track || !slides.length) return;

      var index = 0;
      var maxIndex = slides.length - 1;

      function clamp(n) {
        return Math.max(0, Math.min(maxIndex, n));
      }

      function setIndex(nextIndex) {
        index = clamp(nextIndex);
        track.style.transform = 'translateX(' + (-index * 100) + '%)';

        // dots state
        dots.forEach(function (d, i) {
          var active = i === index;
          d.classList.toggle('is-active', active);
          d.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }

      // buttons
      if (btnPrev) btnPrev.addEventListener('click', function () { setIndex(index - 1); });
      if (btnNext) btnNext.addEventListener('click', function () { setIndex(index + 1); });

      // dots
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var i = parseInt(dot.getAttribute('data-index'), 10);
          if (!isNaN(i)) setIndex(i);
        });
      });

      // keyboard
      viewport.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') setIndex(index - 1);
        if (e.key === 'ArrowRight') setIndex(index + 1);
      });

      // swipe (pointer)
      var startX = 0;
      var isDown = false;

      viewport.addEventListener('pointerdown', function (e) {
        isDown = true;
        startX = e.clientX;
        viewport.setPointerCapture(e.pointerId);
      });

      viewport.addEventListener('pointerup', function (e) {
        if (!isDown) return;
        isDown = false;
        var dx = e.clientX - startX;

        // threshold
        if (Math.abs(dx) > 40) {
          if (dx < 0) setIndex(index + 1);
          else setIndex(index - 1);
        }
      });

      // init
      setIndex(0);
    });
  }

  document.addEventListener('DOMContentLoaded', initCompatSliders);
})();

